import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  CREATE_ASSESSMENT_FAILURE,
  CREATE_ASSESSMENT_REQUEST,
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_LOADING,
} = therapyPlanningAction;

function* createAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: CREATE_ASSESSMENT_LOADING });
    const response = yield call(therapyPlanningService.createAssessment, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: CREATE_ASSESSMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_ASSESSMENT_FAILURE, payload: error });
  }
}

function* createAssessmentSaga() {
  yield takeEvery(CREATE_ASSESSMENT_REQUEST, createAssessment);
}

export default createAssessmentSaga;
